module.exports = __webpack_public_path__ + "img/leaderboard-logo.fe46bb1a.png";